import { SupplierMinimal } from '@retail/suppliers/types';
import { SupplierItemInsightDTO } from '../../dto';
import { EnvironmentInsight } from './EnvironmentInsight';

export type IncludesOrMissing = 'INCLUDES' | 'MISSING';

export interface DocumentationInsight {
  safetyDataSheet: boolean | null;
  productDataSheet: boolean | null;
  userManual: boolean | null;
  explodedView: boolean | null;
  productCatalog: boolean | null;
  performanceDeclaration: boolean | null;
  installationInstructions: boolean | null;
  environmentProductDeclaration: boolean | null;
  constructionProductDeclaration: boolean | null;
  certificate: boolean | null;
  operationAndMaintenance: boolean | null;
  disassemblyInstructions: boolean | null;
}

export interface PictureInsight {
  productImageSingle: boolean | null;
  inContextProductImage: boolean | null;
  productInActionImage: boolean | null;
  productImageGroup: boolean | null;
  brandLogo: boolean | null;
  lineDrawing: boolean;
  colorSampleImage: boolean | null;
  productSurfaceImage: boolean | null;
}

export interface ClimateInsight {
  gtin: string;
  epdProductName: string;
  epdOwner: string;
  epdFunctionalUnit: string;
  epdFunctionalUnitWeight: number;
  epdValidTo: string;
  epdStandard: string;
  epdAssetLink: string;
  epdPublisher: string;
  epdLastModified: string;
  gwp: {
    a1a3FromEpd: number;
    a1a3FromBoverket: number;
    a4FromEpd: number;
    a4FromBoverket: number;
    a5FromEpd: number;
    a5FromBoverket: number;
    c1c4: number;
    d: number;
  };
  source: string;
}

export interface SupplierItemInsightProps {
  mgItemNumber: number;
  finfoNumber: number;
  primaryText: string;
  secondaryText: string;
  supplier: SupplierMinimal;
  etimKl?: string;
  environment?: EnvironmentInsight;
  climate: ClimateInsight;
  documentation: DocumentationInsight;
  pictureData: PictureInsight;
}

export class SupplierItemInsight {
  mgItemNumber: number;
  finfoNumber: number;
  primaryText: string;
  secondaryText: string;
  supplier: SupplierMinimal;
  etimKl?: string;
  environment?: EnvironmentInsight;
  climate: ClimateInsight;
  documentation: DocumentationInsight;
  pictureData: PictureInsight;

  constructor({
    mgItemNumber,
    finfoNumber,
    primaryText,
    secondaryText,
    supplier,
    etimKl,
    environment,
    climate,
    documentation,
    pictureData,
  }: SupplierItemInsightProps) {
    this.mgItemNumber = mgItemNumber;
    this.finfoNumber = finfoNumber;
    this.primaryText = primaryText;
    this.secondaryText = secondaryText;
    this.supplier = supplier;
    this.etimKl = etimKl;
    this.environment = environment;
    this.climate = climate;
    this.documentation = documentation;
    this.pictureData = pictureData;
  }

  static fromDto = (dto: SupplierItemInsightDTO): SupplierItemInsight =>
    new SupplierItemInsight({
      mgItemNumber: dto.mgItemNumber,
      finfoNumber: dto.finfoNumber,
      primaryText: dto.primaryText,
      secondaryText: dto.secondaryText,
      supplier: SupplierMinimal.fromDTO(dto.supplier),
      etimKl: dto.etimKl,
      environment: dto.environment ? EnvironmentInsight.fromDto(dto.environment) : undefined,
      climate: dto.climate,
      documentation: dto.documentation,
      pictureData: dto.pictureData,
    });
}
